module.exports = __webpack_public_path__ + "static/media/table tennis.0a509106.jpg";